module.exports = __webpack_public_path__ + "static/img/ent-10.fc08044.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-10.jpg
// module id = /W7d
// module chunks = 51